import { Button } from './ui'
import { useVersionStore } from '../lib/version'

/** New-deploy prompt: a running console notices the deployed version.json
 *  moved past its boot version and offers a full reload. Never auto-reloads
 *  (a half-finished workbench decision must not be nuked); dismissing
 *  snoozes until the NEXT version change. */
export function UpdateBanner() {
  const updateVersion = useVersionStore((s) => s.updateVersion)
  const dismissed = useVersionStore((s) => s.dismissed)
  const dismiss = useVersionStore((s) => s.dismiss)

  if (updateVersion === null || updateVersion === dismissed) return null

  return (
    <div className="fixed bottom-4 left-1/2 z-50 w-full max-w-md -translate-x-1/2 px-3 sm:w-auto sm:px-0">
      <div
        role="status"
        className="flex flex-wrap items-center gap-3 rounded-sm border border-ostrel-border bg-ostrel-navy px-4 py-2.5 shadow-lg"
      >
        <span className="inline-block h-1.5 w-1.5 shrink-0 animate-pulse rounded-full bg-ostrel-gold" />
        <p className="text-xs text-ostrel-light">A new version of the console is available.</p>
        <Button variant="primary" size="sm" onClick={() => window.location.reload()}>
          Reload
        </Button>
        <button
          type="button"
          onClick={dismiss}
          title="Dismiss until the next update"
          aria-label="Dismiss update notice"
          className="rounded-sm px-1.5 py-1 text-xs text-ostrel-dim transition-colors hover:text-ostrel-light focus:outline-none focus:ring-1 focus:ring-ostrel-gold"
        >
          ✕
        </button>
      </div>
    </div>
  )
}
